import {
  AfterContentInit,
  AfterViewInit,
  Component,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import { DatePipe } from '@angular/common';
import { ModalConfirm } from '../../models/modal-confirm';
import { WarehouseHandlingModal } from '../../models/warehose-handling-modal';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { WarehouseHandlingDetailComponent } from '../warehouse-handling-detail/warehouse-handling-detail.component';
import { WarehouseHandlingReportComponent } from '../warehouse-handling-report/warehouse-handling-report.component';
import { FastWarehouseHandlingComponent } from '../fast-warehouse-handling/fast-warehouse-handling.component';

@Component({
  selector: 'app-warehouse-handling',
  templateUrl: './warehouse-handling.component.html',
  styleUrls: ['./warehouse-handling.component.css'],
})
export class WarehouseHandlingComponent implements AfterViewInit {
  @ViewChild(WarehouseHandlingReportComponent)
  warehouseHandlingReportComponent!: WarehouseHandlingReportComponent;
  @ViewChild(WarehouseHandlingDetailComponent)
  warehouseHandlingDetailComponent!: WarehouseHandlingDetailComponent;
  @ViewChild(FastWarehouseHandlingComponent)
  fastWarehouseHandlingComponent!: FastWarehouseHandlingComponent;

  constructor() { }

  public ngAfterViewInit(): void {
    this.warehouseHandlingReportComponent.LoadPage();
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'WarehouseHandling':
        this.warehouseHandlingReportComponent.ClosePage();
        this.fastWarehouseHandlingComponent.ClosePage();
        this.warehouseHandlingDetailComponent.requestModel.pageNumber = 1;
        setTimeout(() => {
          this.warehouseHandlingDetailComponent.InitPage(event.data);
        }, 700);
        break;
      case 'Return':
        this.warehouseHandlingDetailComponent.ClosePage();
        this.fastWarehouseHandlingComponent.ClosePage();
        this.warehouseHandlingReportComponent.requestModel.pageNumber = 1;
        setTimeout(() => {
          this.warehouseHandlingReportComponent.LoadPage();
        }, 700);
        break;
      case 'FastWarehousingHandling':
        this.warehouseHandlingDetailComponent.ClosePage();
        this.warehouseHandlingReportComponent.ClosePage();
        this.fastWarehouseHandlingComponent.thisWarehouseHandling=new WarehouseHandlingModal();
        this.fastWarehouseHandlingComponent.thisWarehouseHandling.stockId=event.data.stockId;
        this.fastWarehouseHandlingComponent.thisWarehouseHandling.id=event.data.id;
        setTimeout(() => {
          this.fastWarehouseHandlingComponent.LoadPage();
        }, 700);
        break;
      default:
        break;
    }
  }
}
